import moment from "moment";
import { useHistory } from "react-router-dom";
import { addDays } from "date-fns";
const { createSlice } = require("@reduxjs/toolkit");

var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
var firstDay = new Date(y, m, 1);

var date = moment(new Date());
var now = moment(firstDay);
var duration = moment.duration(date.diff(now));
var noofDays = duration.asDays();
const currentMonth = moment().format("MM");
const currentYear = moment().format("YYYY");

const localStorageTimeSeries2 = JSON.parse(localStorage.getItem("TimeSeries2"));

// console.log("loca--", localStorageTimeSeries2);

export const initialState = {
  timeSeries: {
    end: moment(new Date()).format("YYYY-MM-DD"),
    start: moment(addDays(new Date(), -29)).format("YYYY-MM-DD"),
    dateType: "Month",
    buttonClicked: false,
    approveType: "Completed",
    // start: "",
    // end: "",
  },
  timeSeries1: {
    end: moment(new Date()).add(-2, "day").format("YYYY-MM-DD"),
    start: moment(addDays(new Date(), -29)).format("YYYY-MM-DD"),
    dateType: "Month",
    buttonClicked: false,
    approveType: "Completed",
    dateReset:"1M",
    // start: "",
    // end: "",
  },
  // timeSeries2: {
  //   end: moment(new Date()).format("YYYY-MM-DD"),
  //   // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

  //   start: `${currentYear}-${currentMonth}-01`,
  //   dateType: "Month",
  //   buttonClicked: false,
  //   approveType: "Completed",
  //   // start: "",
  //   // end: "",
  // },

  timeSeries2: localStorageTimeSeries2
    ? localStorageTimeSeries2
    : {
        end: moment(new Date()).format("YYYY-MM-DD"),
        start: `${currentYear}-${currentMonth}-01`,
        dateType: "Month",
        buttonClicked: false,
        dateReset:"1M",
        approveType: "Completed",
       
      },
};

const dashboardSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setTimeSeries: (state, { payload }) => {
      state.timeSeries = payload;
    },
    setTimeSeriesDateType: (state, { payload }) => {
      state.timeSeries = {
        ...state.timeSeries,
        dateType: payload,
      };
    },
    setButtonClicked: (state, { payload }) => {
      state.timeSeries = {
        ...state.timeSeries,
        buttonClicked: !state.timeSeries.buttonClicked,
      };
    },
    setTimeSeries1: (state, { payload }) => {
      state.timeSeries1 = payload;
    },
    setTimeSeries2: (state, { payload }) => {
      state.timeSeries2 = payload;
    },
    setTimeSeriesDateType1: (state, { payload }) => {
      state.timeSeries1 = {
        ...state.timeSeries1,
        dateType: payload,
      };
    },
    setButtonClicked1: (state, { payload }) => {
      state.timeSeries1 = {
        ...state.timeSeries1,
        buttonClicked: !state.timeSeries.buttonClicked,
      };
    },
    setApprovedType1: (state, { payload }) => {
      state.timeSeries1 = {
        ...state.timeSeries1,
        approveType: payload,
      };
    },
  },
});

export const {
  setTimeSeries,
  setTimeSeriesDateType,
  setButtonClicked,
  setTimeSeries1,
  setTimeSeries2,
  setTimeSeriesDateType1,
  setButtonClicked1,
  setApprovedType1,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
